import { render, staticRenderFns } from "./Step2Ans.vue?vue&type=template&id=ddbaf1d2"
import script from "./Step2Ans.vue?vue&type=script&lang=js"
export * from "./Step2Ans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports